module.exports = __webpack_public_path__ + "img/logo.2dd88acf.svg";